import request from './.request'
/*
* 地块管理
* */
export function getAreaData(e) {
  return request({
    url: `/land`,
    method:'get',
    params:e
  })
}
export function addAreaData(e) {
  return request({
    url: `/land`,
    method: 'post',
    data:e
  })
}
export function removeAreaData(e) {
  return request({
    url: '/land',
    method: 'delete',
    params:e
  })
}
export function updateAreaData(e) {
  return request({
    url: '/land',
    method: 'put',
    data:e
  })
}

/**
 * 检查地块名称是否重复
 */
export function checkLandName(e) {
  return request({
    url: `/land/${e}?by=name`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/land.js